import * as Yup from 'yup'
import i18next from 'i18next';
import { News } from '../models/News';
import { createSchema } from '../framework/entity/yup';
import moment from 'moment';

//const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const defaultSchema = () => createSchema<News>([
    [x => x.title, Yup.string().required(i18next.t('Il titolo è obbligatorio'))],
    [x => x.subtitle, Yup.string().required(i18next.t('Il Sotto titolo è obbligatorio'))],
    [x => x.body, Yup.string().required(i18next.t('Il testo è obbligatorio')).test('body', i18next.t('Testo non specificato'), (value, context) => {
        
        let item = context.parent as News;
        if (!item || !value) {
            return true;
        }
       
        console.debug('body value', value)
        if (value === '<p></p>\n') {
            return false;
        }
        return true;
    })],
    [x => x.validUntil, Yup.date().required(i18next.t('La data di validità è obbligatoria')).test('validUntil', i18next.t('La data fino a deve essere maggiore di oggi'), (value, context) => {
        
        let item = context.parent as News;
        if (!item || !value) {
            return true;
        }
    
        let today = moment().unix()
        let validUntil = moment(value).unix()
    
        //console.debug('validUntil', today, validUntil)
        if (validUntil <= today) {
            return false;
        }

        return true;
    })],
])

export function getNewsValidationSchema() {

    let schema = defaultSchema();

    //     if (personRequiredField.birth) {
    //         schema = schema.concat(birthSchema());
    //     }
    
    //     if (personRequiredField.residence) {
    //         schema = schema.concat(residenceSchema());
    //     }
    
    //     if (personRequiredField.identification) {
    //         schema = schema.concat(identificationSchema());
    //     }

    //     if (personRequiredField.custom) {
    //         let list: string[] = personRequiredField.fields ? JSON.parse(personRequiredField.fields) : [];
    //         schema = schema.concat(dynamicSchema(list));
    //     }      

    return schema;
}
